goog.provide('el8.uiwidget.TagInput');

goog.require('el8.uiwidget.NewMindreader');
goog.require('el8.template.uiwidget.TagInput');

/**
 * This is a widget for rendering a series of tags in an input,
 * based on selections from a mindreader.
 *
 * The widget will only render objects with IDs (it will not render
 * tags from free-text), but it does have hooks for prompting the user
 * to turn a free-text entry into a saved tag.
 *
 * This will probably be used via tagInputOpts passed into a Form.
 * See, e.g., docTags.js.
 */
el8.uiwidget.TagInput = function(opts) {
    // TagInputs must have an associated mindreader
    this._mindreaderOpts = opts.mindreaderOpts;
    this._mindreader = null;

    this._infoText = opts.infoText || '';
    this._maxLength = opts.maxLength || null;

    // Mandatory parameter: function promptCreateTagFn(str, handleTagItemFn)
    // Should take a string, potentially make a tag out of it (up to the user),
    // and if so pass a tag item dict back to handleTagItemFn
    this._promptCreateTagFn = opts.promptCreateTagFn;

    // Optional parameter: function convertTextToItemFn(str, handleTagItemFn, handleEmptyItemFn)
    // Should take a string, lookup any exact matching tags, and either call
    // handleTagItemFn (same param as above) if one is found or
    // handleEmptyItemFn if not (no param)
    this._convertTextToItemFn = opts.convertTextToItemFn || null;

    this._changeFn = opts.changeFn || null;

    this._tagContainer = opts.tagContainer;

    // Optional
    this._oneOnly = (opts.oneOnly === true);
    this._noPromptCreateTag = (opts.noPromptCreateTag === true);
};

el8.uiwidget.TagInput.prototype.init = function() {
    // map from ID to tag item
    this._selectedItems = {};

    this._tagContainer.html(el8.template.uiwidget.TagInput.content());
    this._input = $(':input', this._tagContainer);

    this._infoField = el8.service.infoField.addInfoField({
        field: this._input,
        infoText: this._infoText,
        maxLength: this._maxLength
    });
    this._initMindreader();

    this._bindTriggers();

    return this;
};

el8.uiwidget.TagInput.prototype.reset = function() {
    this._selectedItems = {};
    this._onSelectedItemsChange();
};

el8.uiwidget.TagInput.prototype.getSelectedIds = function() {
    var strIds = _.pluck(this._selectedItems, 'id');
    return strIds.map(function(id) { return parseInt(id, 10); });
};
el8.uiwidget.TagInput.prototype.getSelectedValues = function() {
    return _.pluck(this._selectedItems, 'value');
};

// addTags and setTags expect list of tag items as soymaps
el8.uiwidget.TagInput.prototype.addTags = function(tagItems) {
    var that = this;

    // If oneOnly, just pick first and replace
    if (this._oneOnly) {
        var first = _.first(tagItems);
        var tagId = parseInt(first.id, 10);
        this._selectedItems = {};
        that._selectedItems[tagId] = first;
    } else {
        tagItems.forEach(function(tagItem) {
            var tagId = parseInt(tagItem.id, 10);
            that._selectedItems[tagId] = tagItem;
        });
    }
    this._onSelectedItemsChange();
};
el8.uiwidget.TagInput.prototype.setTags = function(tagItems) {
    this._selectedItems = {};
    this.addTags(tagItems);
};
el8.uiwidget.TagInput.prototype.addTag = function(tagItem) {
    this.addTags([tagItem]);
};

el8.uiwidget.TagInput.prototype.focusField = function() {
    this._input.focusFocus();
};

el8.uiwidget.TagInput.prototype.destroy = function() {
    this._selectedItems = {};
    this._tagContainer.empty();
};

/* ===================
 * Internal Stuff
 * =================== */
el8.uiwidget.TagInput.prototype._initMindreader = function() {
    var that = this;
    this._mindreaderOpts.changeFn = function() { that._onMindreaderChange(); };
    this._mindreaderOpts.dropdownAnchor = this._tagContainer;

    if (!this._noPromptCreateTag) {
        this._mindreaderOpts.actions = [
            {
                name: 'Add new tag',
                actionFn: function(val) {
                    var handleTagItemFn = _.bind(that.addTag, that);
                    that._promptCreateTagFn(val, handleTagItemFn);
                }
            }
        ];
    }


    this._mindreader = new el8.uiwidget.NewMindreader(this._mindreaderOpts);
    this._mindreader.init(this._input);
};

el8.uiwidget.TagInput.prototype._onMindreaderChange = function() {
    var mr = this._mindreader;
    var newItem = mr.getSelectedItem();
    var strInput = mr.getInputVal();

    // If we didn't get an item selected directly from the MR,
    // see if we got any text. If we did, we'll try to convert
    // that to an existing tag.
    if (el8.util.isNone(newItem)) {
        if (strInput === '') { return; }

        var that = this;
        var handleTagItemFn = _.bind(that.addTag, that);

        if (!this._noPromptCreateTag) {
            if (this._convertTextToItemFn) {
                // will do the lookup async and add the tag later itself if found
                var handleEmptyItemFn = function() {
                    that._promptCreateTagFn(strInput, handleTagItemFn);
                };
                this._convertTextToItemFn(strInput, handleTagItemFn, handleEmptyItemFn);
            } else {
                that._promptCreateTagFn(strInput, handleTagItemFn);
            }
        }
        mr.setInputVal('', true); // true=noTrigger: no circular loops, please
        return;
    }

    if (!newItem.id) {
        // can't add tags without id
        return;
    }
    this.addTag(newItem);
    this._onSelectedItemsChange();
    mr.setInputVal('', true);

    // If the mindreader is supposed to auto-show a list without typing,
    // we'll need to refocus on the field again after the mindreader is hidden.
    // It's a little tricky to guarantee that will happen, but waiting 100ms
    // should be a pretty proxy
    if (this._mindreaderOpts.showOnFocus) {
        _.delay(_.bind(this.focusField, this), 100);
    }
};

el8.uiwidget.TagInput.prototype._bindTriggers = function() {
    var that = this;
    // listening on a container inside _tagContainer will ensure that
    // if we empty _tagContainer, all the listeners get cleaned up
    var $evtContainer = $('.taginput-container', this._tagContainer);

    $evtContainer
        .on('click', '.remove-trigger',  function() {
            var $tagitem = $(this).closest('.taginput-tag-item');
            var tagId = $tagitem.data('id');
            if (!tagId) { return; }

            that._removeTag(tagId);

        }).on('keydown', '.taginput-input',  function(e) {
            // backspace on an empty input deletes the last tag
            if (e.which === $.ui.keyCode.BACKSPACE && that._input.val() === '') {
                that._removeTag(that._lastTagId());

            // left on an empty input highlights the last tag
            } else if (e.which === $.ui.keyCode.LEFT && that._input.val() === '') {
                that._lastTagElt().focus();
            }

        }).on('keydown', '.taginput-tag-item',  function(e) {
            // backspace or delete on a highlighted tag deletes it
            if (e.which === $.ui.keyCode.BACKSPACE || e.which === $.ui.keyCode.DELETE) {
                that._removeTag($(this).data('id'));

            // left on a highlighted tag highlights the previous one
            } else if (e.which === $.ui.keyCode.LEFT) {
                $(this).prev().focus();

            // right highlights the next one (or the input if there isn't a next one)
            } else if (e.which === $.ui.keyCode.RIGHT) {
                var $next = $(this).next();
                if ($next.length) {
                    $next.focus();
                } else {
                    that.focusField();
                }
            }

        });
};

el8.uiwidget.TagInput.prototype._onSelectedItemsChange = function() {
    this._renderTags();
    if (this._changeFn) { this._changeFn(this); }
};
el8.uiwidget.TagInput.prototype._renderTags = function() {
    $('.taginput-tag-list', this._tagContainer).html(
        el8.template.uiwidget.TagInput.tagList({
            tags: _.values(this._selectedItems)
        })
    );
};

el8.uiwidget.TagInput.prototype._removeTag = function(tagId) {
    if (!tagId) { return; }
    tagId = parseInt(tagId, 10);
    delete this._selectedItems[tagId];
    this._onSelectedItemsChange();
    this.focusField();
};

el8.uiwidget.TagInput.prototype._lastTagElt = function() {
    return $('.taginput-tag-item:last', this._tagContainer);
};
el8.uiwidget.TagInput.prototype._lastTagId = function() {
    var $tag = this._lastTagElt();
    if (!$tag.length) { return null; }
    return $tag.data('id');
};
